<template lang="pug">
    v-card.h-full.rounded-lg.d-flex.flex-column.justify-space-between(flat)
        .d-flex.flex-row.justify-space-between.align-center
            div
              v-card-title {{$t('share.publicLink.title')}}
              v-card-subtitle {{$t('share.publicLink.subtitle')}}
        v-card-text.pt-0.pb-1(  v-if="publicUrlEnabled")
          v-text-field.rounded-lg(readonly :value="getPublicUrl" dense hide-details rounded filled )
        v-card-actions.pa-4
            v-btn.px-4.text-normal(depressed v-if="!publicUrlEnabled" :disabled="video.status !== VideoStatus.COMPLETED" :color="copied ? 'accent' : 'primary'" @click="publicLinkSettingChanged") 
              v-icon(small left) fas fa-link
              .mr-2 {{$t('share.publicLink.unlock')}}
            v-btn.px-4.text-normal(depressed  v-if="publicUrlEnabled" :color="copied ? 'accent' : 'primary'" :disabled="!publicUrlEnabled" @click="copyPublicUrl") 
                v-icon(small left) {{copied ? 'fas fa-check' : 'fas fa-copy'}}
                .mr-2 {{copied ? $t('share.publicLink.copyBtnSuccess') : $t('share.publicLink.copyBtn')}}
            v-btn.px-4.text-normal(text v-if="publicUrlEnabled" color="red" @click="publicLinkSettingChanged(false)") 
              | {{$t('share.publicLink.lock')}}
</template>

<script>
import { mapGetters } from "vuex";
import date from "@/utils/date";
import { VideoStatus } from "@/models";
import urlFormat from "@/utils/urlFormat";
// const { ClipboardItem } = window;
export default {
  name: "ShareVideoLink",
  components: {},
  data() {
    return {
      copied: false,
      VideoStatus,
    };
  },

  computed: {
    publicUrlEnabled() {
      return !!this.video.publicToken;
    },
    getPublicUrl() {
      return `${window.location.origin}/share/${this.video.publicToken}`;
    },
    ...mapGetters("videoAsset", {
      video: "selectedVideoAsset",
    }),
  },

  methods: {
    ...date,
    ...urlFormat,
    copyPublicUrl() {
      const publicUrl = this.getPublicUrl; //`${window.location.origin}/share/${this.video.publicToken}`;
      const self = this;
      navigator.clipboard.writeText(publicUrl).then(function () {
        self.copied = true;
        setTimeout(() => {
          self.copied = false;
        }, 2000);
      });
    },
    // copyPublicHTML() {
    //   const publicUrl = `${window.location.origin}/share/${this.video.publicToken}`;
    //   const copyBody = `<a href="${publicUrl}"  style="max-width:400px;width:100%"><img src="${this.displayThumbnail(
    //     this.video
    //   )}" style="max-width:400px;width:100%" /></a><a href="${publicUrl}">Video anschauen</a>`;
    //   var type = "text/html";
    //   var blob = new Blob([copyBody], { type });
    //   var data = [new ClipboardItem({ [type]: blob })];
    //   navigator.clipboard.write(data);
    // },
    async publicLinkSettingChanged(enabled) {
      if (enabled) {
        return this.$store.dispatch("motions/ENABLE_PUBLIC_URL", this.video.id);
      } else {
        return this.$store.dispatch(
          "motions/DISABLE_PUBLIC_URL",
          this.video.id
        );
      }
    },
    displayThumbnail(item) {
      const src = this.getThumbnailUrl(item.id, item.token, item.element);
      return src;
    },
  },
};
</script>
<style lang="sass" scoped>
.h-full
  height: 100%
</style>
